const cardData = {
  smallCard: [
    {
      id: 1,
      imgUrl: "/images/card_small_1.png",
      altText: "Alt Text",
      title: "The Great Show and All Items",
      avatar: "JRE",
      time: "5h ago",
    },
    {
      id: 2,
      imgUrl: "/images/card_small_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 3,
      imgUrl: "/images/card_small_3.png",
      altText: "Alt Text",
      title: "Card on Hover",
      avatar: "Dave Ramsey",
      time: "5h ago",
    },
    {
      id: 4,
      imgUrl: "/images/card_small_4.png",
      altText: "Alt Text",
      title: "How to Start a Podcast Business",
      avatar: "BuzzSprout",
      time: "5h ago",
    },
    {
      id: 5,
      imgUrl: "/images/card_small_5.png",
      altText: "Alt Text",
      title: "All Laid & Back",
      avatar: "Thom Yorke",
      time: "5h ago",
    },
    {
      id: 6,
      imgUrl: "/images/card_small_6.png",
      altText: "Alt Text",
      title: "The Recipe Show",
      avatar: "Radiohead",
      time: "5h ago",
    },
    {
      id: 7,
      imgUrl: "/images/card_small_1.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
    {
      id: 8,
      imgUrl: "/images/card_small_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 9,
      imgUrl: "/images/card_small_3.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
    {
      id: 10,
      imgUrl: "/images/card_small_1.png",
      altText: "Alt Text",
      title: "The Great Show and All Items",
      avatar: "JRE",
      time: "5h ago",
    },
    {
      id: 11,
      imgUrl: "/images/card_small_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 12,
      imgUrl: "/images/card_small_3.png",
      altText: "Alt Text",
      title: "Card on Hover",
      avatar: "Dave Ramsey",
      time: "5h ago",
    },
    {
      id: 13,
      imgUrl: "/images/card_small_4.png",
      altText: "Alt Text",
      title: "How to Start a Podcast Business",
      avatar: "BuzzSprout",
      time: "5h ago",
    },
    {
      id: 14,
      imgUrl: "/images/card_small_5.png",
      altText: "Alt Text",
      title: "All Laid & Back",
      avatar: "Thom Yorke",
      time: "5h ago",
    },
    {
      id: 15,
      imgUrl: "/images/card_small_6.png",
      altText: "Alt Text",
      title: "The Recipe Show",
      avatar: "Radiohead",
      time: "5h ago",
    },
    {
      id: 16,
      imgUrl: "/images/card_small_1.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
    {
      id: 17,
      imgUrl: "/images/card_small_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 18,
      imgUrl: "/images/card_small_3.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
  ],
  mediumCard: [
    {
      id: 1,
      imgUrl: "/images/card_medium_1.png",
      altText: "Alt Text",
      title: "The Great Show and All Items",
      avatar: "Zach & Donald",
      time: "5h ago",
      like: "78.2k",
    },
    {
      id: 2,
      imgUrl: "/images/card_medium_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
      like: "33.4k",
    },
    {
      id: 3,
      imgUrl: "/images/card_medium_3.png",
      altText: "Alt Text",
      title: "Card on Hover",
      avatar: "Dave Ramsey",
      time: "5h ago",
      like: "25.3k",
    },
    {
      id: 4,
      imgUrl: "/images/card_medium_4.png",
      altText: "Alt Text",
      title: "How to Start a Podcast Business",
      avatar: "BuzzSprout",
      time: "5h ago",
      like: "12.5k",
    },
    {
      id: 6,
      imgUrl: "/images/card_medium_1.png",
      altText: "Alt Text",
      title: "The Recipe Show",
      avatar: "Radiohead",
      time: "5h ago",
      like: "45.4k",
    },
    {
      id: 7,
      imgUrl: "/images/card_medium_2.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
      like: "15.4k",
    },
    {
      id: 8,
      imgUrl: "/images/card_medium_3.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
      like: "85.4k",
    },
    {
      id: 9,
      imgUrl: "/images/card_medium_4.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
      like: "25.4k",
    },
    {
      id: 10,
      imgUrl: "/images/card_medium_1.png",
      altText: "Alt Text",
      title: "The Great Show and All Items",
      avatar: "Zach & Donald",
      time: "5h ago",
      like: "78.2k",
    },
    {
      id: 11,
      imgUrl: "/images/card_medium_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
      like: "33.4k",
    },
    {
      id: 12,
      imgUrl: "/images/card_medium_3.png",
      altText: "Alt Text",
      title: "Card on Hover",
      avatar: "Dave Ramsey",
      time: "5h ago",
      like: "25.3k",
    },
    {
      id: 13,
      imgUrl: "/images/card_medium_4.png",
      altText: "Alt Text",
      title: "How to Start a Podcast Business",
      avatar: "BuzzSprout",
      time: "5h ago",
      like: "12.5k",
    },
    {
      id: 14,
      imgUrl: "/images/card_medium_1.png",
      altText: "Alt Text",
      title: "The Recipe Show",
      avatar: "Radiohead",
      time: "5h ago",
      like: "45.4k",
    },
    {
      id: 15,
      imgUrl: "/images/card_medium_2.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
      like: "15.4k",
    },
    {
      id: 16,
      imgUrl: "/images/card_medium_3.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
      like: "85.4k",
    },
    {
      id: 17,
      imgUrl: "/images/card_medium_4.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
      like: "25.4k",
    },
  ],
  largeCard: [
    {
      id: 1,
      imgUrl: "/images/card_normal_1.png",
      altText: "Alt Text",
      title: "The Great Show and All Items",
      avatar: "Zach & Donald",
      time: "5h ago",
    },
    {
      id: 2,
      imgUrl: "/images/card_normal_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 3,
      imgUrl: "/images/card_normal_3.png",
      altText: "Alt Text",
      title: "Card on Hover",
      avatar: "Dave Ramsey",
      time: "5h ago",
    },
    {
      id: 4,
      imgUrl: "/images/card_normal_1.png",
      altText: "Alt Text",
      title: "How to Start a Podcast Business",
      avatar: "BuzzSprout",
      time: "5h ago",
    },
    {
      id: 6,
      imgUrl: "/images/card_normal_2.png",
      altText: "Alt Text",
      title: "The Recipe Show",
      avatar: "Radiohead",
      time: "5h ago",
    },
    {
      id: 7,
      imgUrl: "/images/card_normal_3.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
  ],
  tineCard: [
    {
      id: 1,
      imgUrl: "/images/card_tiny_1.png",
      altText: "Alt Text",
      title: "The Great Show and All Items",
      avatar: "Zach & Donald",
      time: "5h ago",
    },
    {
      id: 2,
      imgUrl: "/images/card_tiny_2.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 3,
      imgUrl: "/images/card_tiny_3.png",
      altText: "Alt Text",
      title: "Card on Hover",
      avatar: "Dave Ramsey",
      time: "5h ago",
    },
    {
      id: 4,
      imgUrl: "/images/card_tiny_4.png",
      altText: "Alt Text",
      title: "How to Start a Podcast Business",
      avatar: "BuzzSprout",
      time: "5h ago",
    },
    {
      id: 6,
      imgUrl: "/images/card_tiny_5.png",
      altText: "Alt Text",
      title: "The Recipe Show",
      avatar: "Radiohead",
      time: "5h ago",
    },
    {
      id: 7,
      imgUrl: "/images/card_tiny_6.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
    {
      id: 8,
      imgUrl: "/images/card_tiny_7.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 9,
      imgUrl: "/images/card_tiny_8.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
    {
      id: 10,
      imgUrl: "/images/card_tiny_1.png",
      altText: "Alt Text",
      title: "Stuff you should know",
      avatar: "The Tim Ferris Show",
      time: "5h ago",
    },
    {
      id: 11,
      imgUrl: "/images/card_tiny_2.png",
      altText: "Alt Text",
      title: "The Great Show and All",
      avatar: "JRE",
      time: "5h ago",
    },
  ],
};

export function getCardData() {
  return cardData;
}
